const colors = {
    primary: "#78529c",
    secondary: "#71bb73",
    black: "#202020",
    light: "#fcf4ff",

    bt: {
        primary: "#9B59B6FF",
    }
}

export default colors